
<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator">
          <a-button :loading="loading" style="margin-right: 10px" type="primary" icon="plus" @click="handleAdd">创建新试卷</a-button>
          <a-popconfirm
            title="确定要批量删除吗?"
            @confirm="batchDel" >
            <a-button icon="delete" >批量删除</a-button>
          </a-popconfirm>
          <a-button style="margin-right: 10px" type="default" icon="download" @click="handleDownLoad">下载</a-button>
        </div>
        <!--表格-->
        <div class="table">
          <a-table
            :columns="table.columns"
            :rowKey="record => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            @change="handleTableChange"
            :rowSelection="rowSelection"
            :scroll="{x:1220}"
          >
            <template slot="actions" slot-scope="text, record">
              <a href="javascript:;" @click="() => handleDownLoad(record.name)">下载试卷</a>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="() => handleDownLoad(record.nameWithAnswer)">下载试卷及答案</a>
              <a-divider type="vertical" />
              <a-popconfirm v-if="table.data.length" title="确定要删除吗?" @confirm="() => onDelete(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <import-modal ref="importModal" @refreshTable="initTableData"></import-modal>
    <view-modal ref="viewModal"></view-modal>
  </div>
</template>

<script>
import { insertPaper, getPaperList, deletePaper, paperDownload } from '@/api/paper'
import editModal from './modules/editModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
import importModal from './modules/importModal'
import viewModal from './modules/viewModal'
export default {
  name: 'PaperList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
  },
  computed: {

  },
  components: {
    editModal,
    searchForm,
    baseCard,
    importModal,
    viewModal
  },
  data () {
    return {
      loading: false,
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      table: {
        data: [],
        config: {},
        columns: [{
          title: '编号',
          dataIndex: 'id' }, {
          title: '试卷名称',
          dataIndex: 'name' }, {
          title: '试卷答案',
          dataIndex: 'nameWithAnswer' }, {
          title: '生成时间',
          dataIndex: 'createTime' }, {
          title: '操作',
          fixed: 'right',
          scopedSlots:
                {
                  customRender: 'actions'
                }
        }],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    // 下载试卷
    handleDownLoad (fileName) {
      paperDownload(fileName).then(res => {
        console.log('试卷下载成功')
        const blob = new Blob([res])
        const downloadElement = document.createElement('a') // 创建下载的链接
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = fileName // 下载后的文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 下载
        document.body.removeChild(downloadElement) // 下载完成 移除 a
        window.URL.revokeObjectURL(href) // 释放blob对象
      }).catch(error => {
        console.log('试卷下载失败', error)
      })
    },
    // 获取选中的table
    rowSelectChange (value) {
      this.selectedRows = value
    },
    // 导入
    handleImport () {
      this.$refs.importModal.setModel(this.model)
      this.$refs.importModal.open(true)
    },
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    initTableData () {
      getPaperList(this.searchModel)
        .then(res => {
          if (res.status === 0) {
            this.table.loading = false
            this.table.data = res.data.list
            this.pagination.total = res.data.total
          } else {
            this.$message.error('获取数据失败！')
          }
        })
        .finally(() => {
        })
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchModel,
        ...this.pagination
      }
      this.initTableData()
    },
    // 删除操作
    onDelete (model) {
      const data = {
        ids: model.id
      }
      deletePaper(data).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 查看详情
    handleView (model) {
      this.$refs.viewModal.setTitle('查看试卷信息')
      this.$refs.viewModal.setModel(model) // 先设置类型，再打开
      this.$refs.viewModal.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑试卷信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 新增
    handleAdd () {
      this.loading = true
      insertPaper().then(res => {
        if (res && res.status === 0) {
          this.initTableData()
          this.$message.success('新增试卷成功！')
        } else {
          this.$message.warning('新增试卷失败！')
        }
        this.loading = false
      }).catch(error => {
        this.loading = false
        this.$message.warning('新增试卷失败！')
      })
      // this.$refs.editModal.setTitle('新增试卷信息')
      // this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)// 先设置类型，再打开
      // this.$refs.editModal.open(true)
    },
    // 批量删除
    batchDel () {
      const searchModel = this.selectedRows
      if (!searchModel || searchModel.length === 0) {
        this.$message.error('请至少选择一行数据进行删除！')
        return
      }
      let params = ''
      searchModel.map(item => {
        params += item.id + ','
      })
      params = params.substring(0, params.length - 1)
      const data = {
        ids: params
      }
      deletePaper(data).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    }
  }
}
</script>

<style scoped  lang="less">
.listContent {
  .table {
    margin-top: 10px;
  }
}
</style>
